<!-- This is similar to the Jinja2 `dataset/search-result.html` template but in
Vue. -->

<template>
  <article class="dataset-card height-auto dataset-search-result py-xs">
    <div class="card-logo search-logo-card" v-if="organization">
      <Placeholder
        type="dataset"
        :src="organization.logo_thumbnail"
        :alt="organization.name"
      />
      <div class="logo-badge logo-badge--bottom-right">
        <span v-html="lock" v-if="private" />
        <span v-html="certified" v-else-if="organizationCertified" />
      </div>
    </div>
    <div class="card-logo search-logo-card" v-else-if="owner">
      <Avatar :user="owner" :size="100" />
    </div>
    <div class="card-logo" v-else>
      <Placeholder type="dataset" />
    </div>
    <div class="card-data search-logo-card">
      <h4 class="card-title">{{ title }}</h4>
      <div class="card-description mt-xs">
        {{ $filters.excerpt(description) }}
      </div>
    </div>
    <!-- <div class="card-hover-datacenter">
      <dl v-if="temporal_coverage">
        <dt>{{$t("from")}}</dt>
        <dd>{{temporal_coverage.start}}</dd>
      </dl>
      <dl v-if="temporal_coverage">
        <dt>{{$t("to")}}</dt>
        <dd>{{temporal_coverage.end}}</dd>
      </dl>
    </div> -->
    <!-- <div class="card-hover-data">
      <dl v-if="frequency">
        <dt>{{ $t("Frequency") }}</dt>
        <dd>{{ frequency }}</dd>
      </dl>
      <dl v-if="geoZone">
        <dt>{{ $t("Spatial coverage") }}</dt>
        <dd>{{ geoZone.join(", ") }}</dd>
      </dl>
    </div>
    <div class="card-hover-data">
       <dl v-if="spatial?.granularity">
        <dt>{{ $t("Territorial coverage granularity") }}</dt>
        <dd>{{ spatial.granularity }}</dd>
      </dl> 
    </div> -->
    <ul class="card-hover-data">
      <li>        
        {{ $t("resources", resources.length || 0) }}
        <div><span>{{ resources.length || 0 }}</span></div>
      </li>
      <li>        
        {{ $t("reuses", metrics.reuses || 0) }}
        <div><span>{{ metrics.reuses || 0 }}</span></div>
      </li>
      <li>        
        {{ $t("favourites", metrics.followers || 0) }}
        <div><span>{{ metrics.followers || 0 }}</span></div>
      </li>
    </ul>
  </article>
</template>

<script>
import Placeholder from "../utils/placeholder";
import certified from "svg/certified.svg";
import lock from "svg/private.svg";
import useOrganizationCertified from "../../composables/useOrganizationCertified";
import useGeoZone from "../../composables/useGeoZone";
import Avatar from "../discussions/avatar";

export default {
  props: {
    title: String,
    organization: Object,
    owner: Object,
    description: String,
    temporal_coverage: Object,
    frequency: String,
    spatial: Object,
    metrics: Object,
    resources: Array,
    private: Boolean,
  },
  components: {
    Avatar,
    Placeholder,
  },
  setup(props) {
    const {organizationCertified} = useOrganizationCertified(props.organization)
    const {geoZone} = useGeoZone(props.spatial)
    return {
      certified,
      lock,
      organizationCertified,
      geoZone,
    };
  }
};
</script>
